import { render, staticRenderFns } from "./selectWay.vue?vue&type=template&id=051d027e&scoped=true&"
import script from "./selectWay.vue?vue&type=script&lang=js&"
export * from "./selectWay.vue?vue&type=script&lang=js&"
import style0 from "./selectWay.vue?vue&type=style&index=0&id=051d027e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d027e",
  null
  
)

export default component.exports